import { z } from 'zod';

export const GetCurationsOrderListServiceRequestSchema = z.object({
  type: z.enum(['GOODS', 'SNAP2']).optional(),
});

export type GetCurationsOrderListServiceRequest = z.infer<
  typeof GetCurationsOrderListServiceRequestSchema
>;

export const GetCurationsOrderListServiceResponseSchema = z.object({
  curations: z.array(
    z.object({
      curationId: z.union([z.number(), z.string()]),
      title: z.string(),
      ordNo: z.number(),
      type: z.enum(['GOODS', 'SNAP2']).nullish(),
    }),
  ),
});

export type GetCurationsOrderListServiceResponse = z.infer<
  typeof GetCurationsOrderListServiceResponseSchema
>;
